export default "__VITE_ASSET__BsAWCLJ5__"